import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string, showMonthYear: boolean): string {
    const isoDateRegex =
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$|^\d{4}-\d{2}-\d{2}T00:00:00$/;
    if (isoDateRegex.test(value)) {
      const [year, month, day] = value.split('T')[0].split('-');
      return showMonthYear ? `${month}/${year}` : `${month}/${day}/${year}`;
    }
    return value;
  }
}
